import axios from "axios";
import { DesEncriptar } from "./Util/Encripcion";
import swal from "sweetalert";


// Este código es para validar que entorno es

// Determinar ruta  según entorno
let apiPath = process.env.REACT_APP_API_URL;
//console.log("apiPath: ", apiPath);
if (process.env.REACT_APP_ENV === "dev") {
  apiPath = process.env.REACT_APP_API_PATH_DEV;
}

const baseURL = `${process.env.REACT_APP_API_URL}${apiPath}`;

//console.log("baseURL:", baseURL);
const instance = axios.create({
  baseURL: baseURL, // URL base de tu API
});

// Interceptor de petición: modifica la URL antes de enviarla
instance.interceptors.request.use(
  (config) => {
    //console.log("config:", config);
    if (process.env.REACT_APP_ENV === "dev") {
      const prodPath = process.env.REACT_APP_API_PATH_PROD;
      apiPath = process.env.REACT_APP_API_PATH_DEV;
      config.url = config.url.replace(prodPath, apiPath);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

  instance.interceptors.response.use(
  (response) => {
    if (response.status == 200) {
      const requestURL = response.config.url;

      // Si la respuesta es de tipo blob (ej. descarga de archivos), no intentar desencriptar
      if (response.config.responseType === 'blob' || response.config.responseType === 'arraybuffer') {
        return response;
      }

      //if (requestURL.includes("login")) {
      ////console.log("PATH ES LOGIN");
      //} else {
      ////console.log("response.data.datos:", response.data.datos);
      if (response.data && response.data.datos) {
        var desencriptado = DesEncriptar(response.data.datos);
        //console.log("Datos desencriptados:"+requestURL+"  ", desencriptado);
        //response.data.datos=desencriptado;
        response.data = JSON.parse(desencriptado);
      }
      //}
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      swal("Aviso", "Su sesión ha expirado!!", "warning").then(() => {
        // Esto se ejecuta cuando el usuario hace clic en OK
        window.location.reload();
        return new Promise(() => {});
      });
      
    }else{
      swal("Aviso", "Ha ocurrido un error por favor intente de nuevo!!", "warning").then(() => {
        // Esto se ejecuta cuando el usuario hace clic en OK
        window.location.reload();
        return new Promise(() => {});
      });
    }
    return Promise.reject(error);
  }
);

export default instance;
